import React, { useContext } from 'react'
import { Box, Button, useMediaQuery, useTheme } from '@mui/material'
import { OfrecerPremiumContext } from '../../../context/OfrecerPremium/ofrecerPremium.context'
import { useAnalytics } from '../../../hooks/useAnalytics'
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined'

const BotonPremium: React.FC<any> = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { onOpen } = useContext(OfrecerPremiumContext)
  const { track } = useAnalytics()

  const handleOpenPre = () => {
    track('vendor_premium_popup_abrir', {
      origin: 'estadisticas'
    })
    onOpen()
  }
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'center',
        ...(isMobile && { marginBottom: '4.5rem' })
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#FF9500'
        }}
      >
        <RocketLaunchOutlinedIcon sx={{ fontSize: '24px' }} />
        <span style={{ fontWeight: 600, fontSize: '15px', color: '#000' }}>Disponible para cuentas premium</span>
      </Box>

      <Button
        onClick={handleOpenPre}
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: '#5B7FFF',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '15px',
          textTransform: 'none',
          padding: isMobile ? '6px 12px' : '12px 24px',
          borderRadius: '20px',
          '&:hover': {
            backgroundColor: '#4A6FEE'
          }
        }}
      >
        QUIERO SER PREMIUM
      </Button>
    </Box>
  )
}

export default BotonPremium
